import React from 'react';
import PropTypes from 'prop-types';
import intl from 'react-intl-universal';
import classNames from 'classnames';
import AttachFile from '@material-ui/icons/AttachFile';
import { random } from 'lodash';
import { formatDateTime } from 'src/helpers/date';
import { getToProperty } from 'src/helpers';
import { MESSAGEBOX_VIEWS, MESSAGEBOX_TYPES } from 'src/constants/constants';
import { MESSAGE_PREVIEW_CHARLIMIT } from 'src/constants/constants';
import PriorityHigh from '@material-ui/icons/PriorityHigh';
import _ from 'lodash';
// import Avatar from 'src/ui/library/Avatar';

export default function ListItemPres({
  checkBoxHandler,
  dashboardSelectMessage,
  dashboardStoreSelectedMessageId,
  details: { read, to, from, caseId, subject, preview, id, priority, hasAttachment, ticketNumber, sentOn },
  history,
  isComposeView,
  isDashboardMessages,
  isDelete,
  isDraftView,
  index,
  selectedIndex,
  selectedMenu,
  selectMessage,
  status,
  switchView,
  resetFilterLoader,
  resetMessageLoader,
  refreshUnReadMessage,
}) {
  const [randomColor] = React.useState(`rgb(${random(130)}, ${random(130)}, ${random(130)})`);
  const listContainerClass = classNames({
    'content-container': true,
    selected: !(isDraftView || isComposeView) && selectedIndex === id,
    unread: read === false,
  });

  // React.useEffect(() => {
  //   resetFilterLoader();
  //   resetMessageLoader();
  // });

  const showMessage = (id, read) => {
    if (!isDashboardMessages) {
      selectMessage(id);
      if (!isDraftView) {
        switchView(MESSAGEBOX_VIEWS.DETAILS);
        refreshUnReadMessage(!read);
      }
    } else {
      dashboardStoreSelectedMessageId(id);
      dashboardSelectMessage();
    }
  };

  // need to review this right now HTML comes in the preview. it's probably best FE sends preview
  // over to the API with just text of what shoudld be shown
  const previewText = preview ? preview.replace(/<(?:.|\n)*?>/gm, '') : '';
  const previewTruncated =
    previewText && previewText.length > MESSAGE_PREVIEW_CHARLIMIT
      ? previewText.substring(0, MESSAGE_PREVIEW_CHARLIMIT) + '...'
      : previewText;
  const subjectTruncated =
    subject && subject.length > MESSAGE_PREVIEW_CHARLIMIT - 40 ? subject.substring(0, MESSAGE_PREVIEW_CHARLIMIT - 40) + '...' : subject;
  let name = to && to.length > 0 ? _.first(to).name || '' : _.first(from) ? _.first(from).name : '';
  const toProp = selectedMenu === MESSAGEBOX_TYPES.INBOX ? name + (from[0].company ? ', ' + from[0].company : '') : getToProperty(to);
  const nameInitials = name
    .split(' ')
    .map(np => np.charAt(0).toUpperCase())
    .join('');

  return (
    <div className="list-item">
      {isDelete && (
        <div className="input-container">
          <input type="checkbox" className="delete-input" onChange={checkBoxHandler.bind(this, id)} />
        </div>
      )}
      <button
        className={listContainerClass}
        aria-label={`View message from ${toProp} on ${formatDateTime(sentOn)}`}
        onClick={showMessage.bind(this, id, read)}>
        <section className="from-wrapper">
          <div className="profile-img" style={{ background: randomColor }}>
            {nameInitials}
          </div>
          {/* <Avatar
            className="profile-img"
            person={from[0] && { id: from[0].id, type: from[0].entityName }}
            altText={name}
            renderFallback={() => (
              <div className="profile-img" style={{ background: randomColor }}>
                {nameInitials}
              </div>
            )}
          /> */}
          <div className="from-details">
            <div className="to">{toProp}</div>
            {ticketNumber && (
              <div className="case-id">
                {intl.get('messaging.list.caseid')}: {ticketNumber}
              </div>
            )}
          </div>
          <div className="time-sent">
            {priority === 'High' && <PriorityHigh className="priority-high" />}
            {hasAttachment && <AttachFile className="icon sm" />}
            {formatDateTime(sentOn)}
          </div>
        </section>
        <section className="subject">{subjectTruncated}</section>
        <section className="preview" dangerouslySetInnerHTML={{ __html: previewTruncated }} />
      </button>
    </div>
  );
}

ListItemPres.propTypes = {
  details: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  selectMessage: PropTypes.func.isRequired,
  checkBoxHandler: PropTypes.func.isRequired,
  isDelete: PropTypes.bool.isRequired,
};
